export const sv = {
  noCompaniesFound: 'Inga företag hittades.',
  goToDashboard: 'Gå till dashboard',
  roleOwner: 'Ägare',
  roleManager: 'Chef',
  roleMechanic: 'Mekaniker',
  roleStaff: 'Personal',
  headingSelect: 'Välj företag',
  headingSwitch: 'Byt företag',
  descMultiple: 'Du har tillgång till flera företag. Välj vilket du vill arbeta med.',
  descSwitch: 'Välj vilket företag du vill arbeta med just nu.',
  typeGarage: 'Verkstad',
  typeCarCare: 'Bilvård',
  cancel: 'Avbryt',
}

export const en: typeof sv = {
  noCompaniesFound: 'No companies found.',
  goToDashboard: 'Go to dashboard',
  roleOwner: 'Owner',
  roleManager: 'Manager',
  roleMechanic: 'Mechanic',
  roleStaff: 'Staff',
  headingSelect: 'Select company',
  headingSwitch: 'Switch company',
  descMultiple: 'You have access to several companies. Choose which one you want to work with.',
  descSwitch: 'Choose which company you want to work with right now.',
  typeGarage: 'Garage',
  typeCarCare: 'Car care',
  cancel: 'Cancel',
}
